// src/components/NotificationSnackbar.js
import React from "react";
import { observer } from "mobx-react-lite";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { useStore } from "../../stores";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const NotificationSnackbar = observer(() => {
  const { uiStore } = useStore();
  const { notification } = uiStore;

  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    uiStore.hideNotification();
  };

  return (
   <Snackbar
    open={notification.open}
    autoHideDuration={notification.duration}
    onClose={handleClose}
    anchorOrigin={{ vertical: "top", horizontal: "right" }}
  >
    <Alert
      onClose={handleClose}
      severity={notification.severity}
      sx={{ width: "100%" }}
    >
      {notification.message}
    </Alert>
</Snackbar>
  );
});

export default NotificationSnackbar;
